import { render, staticRenderFns } from "./HotelCard.vue?vue&type=template&id=41a04c16&scoped=true&"
import script from "./HotelCard.vue?vue&type=script&lang=js&"
export * from "./HotelCard.vue?vue&type=script&lang=js&"
import style0 from "./HotelCard.vue?vue&type=style&index=0&id=41a04c16&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a04c16",
  null
  
)

export default component.exports